import dynamic from "next/dynamic";
import { guardClosedSite } from "@/lib/site-schedule/closed-guard";
import Album from "@/components/Product/Album";
import Detail from "@/components/Product/Detail";
// import { AllBranches } from "@/components/Product/Branches";
import { useContext, useEffect, useState, useRef, useMemo } from "react";
const FreeProduct = dynamic(() => import("@/components/Product/FreeProduct"), {
  ssr: false,
});
const ProductsBundle = dynamic(
  () => import("@/components/Product/ProductsBundle2"),
  { ssr: false }
);
const Descriptions = dynamic(
  () => import("@/components/Product/Descriptions"),
  { ssr: false }
);
const FlixMedia = dynamic(() => import("@/components/Product/FlixMedia"), {
  ssr: false,
});
const TTLStreamContent = dynamic(
  () => import("@/components/Product/ttl-stream"),
  { ssr: false }
);
const Rating = dynamic(() => import("@/components/Product/Rating"), {
  ssr: false,
});
const LastProductAlgolia = dynamic(
  () => import("@/components/Product/LastProductAlgolia"),
  { ssr: false }
);
const AddNewRate = dynamic(() => import("@/components/Product/AddNewRate"), {
  ssr: false,
});
// this is named export so it has to be extracted after import
const AllBranches = dynamic(
  () => import("@/components/Product/Branches").then((mod) => mod.AllBranches),
  { ssr: false }
);
import ProductBreadCrumb from "@/components/Product/ProductBreadCrumb";
import SEO from "@/components/seo";
import { useRouter } from "next/router";
import useSWR from "swr";
import {
  getCurrentDateTime,
  getDisplayedProductPrice,
  product_meta_desc,
} from "@/utils/product";
import { buildCanonicalUrl } from "@/utils/canonical";
import { productRatings } from "@/services/product/product";
import { STORE_LOCATOR } from "@/services/product";
import {
  getActivePdpDetails,
  getProductBySku,
} from "@/services/elasticsearch/getProduct";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { event_select_promotion, event_view_promotion, event_product_viewed } from "@/utils/gtm";
import AWSPersonalizeCtx from "@/contexts/aws-personalize/aws-personalize-context";
import { IS_TYPESENSE_GLOBAL } from "@/utils/typesense/config";
import { tssGetProductBySkuWithPreset } from "@/services/typesense/getProductBySku";
import Cookies from "js-cookie";
import { handshakeCookieName } from "@/constants";
import { localeHandShake } from "@/services/token/handshake";
import { getExtendedWarrantyOptions } from "@/services/extended-warranty/extended-warranty";
import { trackViewProduct } from "@/utils/searchClients";
import { formatToDate } from "@/utils/global";
import { getPaymentMethodsExtraInfo } from "@/services/paymentMethods";
import { serializeJsonLd } from "@/utils/serializeJsonLd";

const ProductDetailsPage = ({
  product: productData,
  pdp_details,
  paymentWidgets,
  isMobile,
  extendedWarranty,
}) => {
  // const [product, setProduct] = useState(productData);
  const { t } = useTranslation("product");
  const { locale, query } = useRouter();
  const [addRate, setAddRate] = useState(false);
  const [city, setCity] = useState("");
  const [showBranches, setShowBranches] = useState(false);
  const [ratings, setRatings] = useState();
  const [store, setStore] = useState();
  const region_id = Cookies.get("region_id");

  const indexName =
    locale === "en"
      ? process.env.NEXT_PUBLIC_ALGOLIA_IDX_EN
      : process.env.NEXT_PUBLIC_ALGOLIA_IDX_AR;

  const prevTrackValuesRef = useRef({
    entity_id: null,
    indexName: null,
  });

  useEffect(() => {
    if (!productData?.entity_id) return;

    const prev = prevTrackValuesRef.current;
    const currentEntityId = `${productData?.entity_id}`;

    const shouldTrack =
      currentEntityId !== prev.entity_id || indexName !== prev.indexName;

    if (shouldTrack) {
      setTimeout(() => {
        trackViewProduct(currentEntityId, indexName);
        prevTrackValuesRef.current = {
          entity_id: currentEntityId,
          indexName,
        };
      }, 500);
    }
  }, [productData?.entity_id, indexName]);

  // useEffect(() => {
  //   setProduct(productData);
  // }, [productData]);

  const currentDateTime = getCurrentDateTime();

  // integration with aws personalize
  const { isDirectConnectToAWS, sendPersonalizeEvent } =
    useContext(AWSPersonalizeCtx);

  useEffect(() => {
    if (
      isDirectConnectToAWS &&
      process.env.NEXT_PUBLIC_NODE_ENV === "production" &&
      !productData?.sku?.includes("___")
    ) {
      sendPersonalizeEvent([
        {
          eventType: "View",
          sentAt: Date.now(),
          itemId: productData?.sku,
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDirectConnectToAWS, productData.sku]);

  const regionId =
    region_id && region_id != "NaN" && region_id != "undefined"
      ? region_id
      : "1101";

  // Checker of Parent ID
  const checkPArentID = (indexOfOffer) => {
    let existParentId = productData?.bundle_discount_products[
      indexOfOffer
    ]?.parent_ids.find((parentIDD) => parentIDD == productData?.entity_id);

    if (existParentId) {
      return true;
    } else {
      return false;
    }
  };

  // useEffect(() => {
  //   const handleFetchAndSetProducts = async () => {
  //     const cachedData = await mutate(cacheKey);
  //     const cachedProducts = cachedData?.data;
  //     const cachedRelatedUpSaleSkus = cachedData?.allProductsSkusObj;

  //     if (cachedProducts?.length) {
  //       handleSetAndFetchProducts(
  //         cachedProducts,
  //         cachedRelatedUpSaleSkus,
  //         setSameBrandProducts,
  //         setRelatedProducts
  //       );
  //     } else {
  //       const res = await refetchAllProducts();

  //       if (res?.data?.length) {
  //         handleSetAndFetchProducts(
  //           res?.data,
  //           res?.allProductsSkusObj,
  //           setSameBrandProducts,
  //           setRelatedProducts
  //         );
  //       }
  //     }
  //   };
  //   handleFetchAndSetProducts();
  // }, [
  //   cachedPDPProducts?.data?.data,
  //   cachedPDPProducts?.data?.relatedUpSaleSkus,
  //   refetchAllProducts,
  //   cacheKey,
  // ]);

  // fetch product ratings
  useSWR(
    () =>
      productData?.sku
        ? `productRatings-${productData?.sku}-${regionId}`
        : null,
    () => productRatings(undefined, productData?.sku),
    {
      revalidateOnMount: 30 * 60 * 1000,
      revalidateOnFocus: false,
      onSuccess: ({ data }) => {
        setRatings(data?.data);
      },
    }
  );

  // fetch store locator by product
  const {} = useSWR(
    () => `Store-locator-${productData?.entity_id}-${regionId}`,
    () => (productData?.entity_id ? STORE_LOCATOR(productData?.entity_id) : {}),
    {
      revalidateOnMount: 30 * 60 * 1000,
      revalidateOnFocus: false,
      onSuccess: ({ data }) => {
        setStore(data?.data?.data);
      },
    }
  );

  // GTM
  useEffect(() => {
    const item = productData;
    const subset = (({
      name,
      sku,
      _category_,
      prices_with_tax,
      option_text_brand,
      stock,
    }) => ({
      item_name: Array.isArray(name) ? name?.at(0) : name,
      item_id: sku,
      item_category: _category_?.main_category?.name,
      price: (+prices_with_tax?.price || +"")?.toFixed(2),
      item_brand: option_text_brand?.[0],
      quantity: stock?.qty,
      discount: null,
    }))(item);

    query.event == "select_promotion" &&
      event_select_promotion(null, null, query?.promotion_id, null, "SAR", [
        subset,
      ]);
    query.gtm &&
      event_view_promotion(null, null, query?.promotion_id, null, "SAR", [
        subset,
      ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productData]);

  // GTM - product_viewed (view_item)
  useEffect(() => {
    if (!productData?.sku) return;
     const productName = Array.isArray(productData?.name)
      ? productData?.name?.at(0)
      : productData?.name;
    const brand = Array.isArray(productData?.option_text_brand)
      ? productData?.option_text_brand?.at(0)
      : productData?.option_text_brand;
    const cat = productData?._category_;
    event_product_viewed(
      productData?.sku,
      productName,
      productData?.prices_with_tax?.price,
      productData?._media_?.image?.[0]?.image || null,
      brand,
      cat?.main_category?.id || null,
      cat?.main_category?.name || null,
      cat?.sub_categories?.[0]?.id || null,
      cat?.sub_categories?.[0]?.name || null,
      productData?.type_id || null
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productData?.sku]);

  // End of GTM
  const ADDITIONAL_PROPERTY_EXCLUDED_LABELS = ["SKU", "Model", "Brand", "Color"];
  const additionalProperty = Array.isArray(productData?.product_attributes)
    ? productData.product_attributes
        .filter(
          (attr) =>
            !ADDITIONAL_PROPERTY_EXCLUDED_LABELS.includes(attr?.["2"]?.label)
        )
        .map((attr) => {
          const localized = attr?.[locale === "ar" ? "14" : "2"];
          const name = localized?.label?.toString().trim();
          const value = localized?.value?.toString().trim();
          return name && value
            ? {
                "@type": "PropertyValue",
                name,
                value,
              }
            : null;
        })
        .filter(Boolean)
    : [];

  const productScheema = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name:
      (Array.isArray(productData?.name)
        ? productData?.name?.at(0)
        : productData?.name) || "",
    image: productData?._media_?.image?.[0]?.image || "",
    description: product_meta_desc(productData?.name, locale),
    brand: {
      "@type": "Brand",
      name: productData?.option_text_brand?.[0] || "",
    },
    ...(productData?.sku && { sku: productData.sku }),
    ...(productData?.model?.[0] && { mpn: productData.model[0] }),
    ...(productData?.gtin?.[0] && { gtin: productData.gtin[0] }),
    ...(productData?.option_text_color?.[0] && {
      color: productData.option_text_color[0],
    }),
    ...(additionalProperty.length > 0 && { additionalProperty }),
    offers: {
      "@type": "Offer",
      url: `https://www.almanea.sa/${locale === "en" ? "en/" : ""}product/${
        productData?.rewrite_url || ""
      }`,
      priceCurrency: "SAR",
      price: (+productData?.prices_with_tax?.price || 0).toFixed(2),
      priceValidUntil:
        formatToDate(productData?.prices_with_tax?.discounted_price_to) ||
        `${new Date().getFullYear()}-12-31`,
      availability: "https://schema.org/InStock",
      itemCondition: "https://schema.org/NewCondition",
      eligibleRegion: {
        "@type": "Country",
        name: "Saudi Arabia",
        alternateName: "KSA",
      },
      priceSpecification: [
        {
          "@type": "UnitPriceSpecification",
          price: (+productData?.prices_with_tax?.price || 0).toFixed(2),
          priceCurrency: "SAR",
          priceType: "https://schema.org/SalePrice",
        },
        {
          "@type": "UnitPriceSpecification",
          price: (
            +productData?.prices_with_tax?.original_price ||
            +productData?.prices_with_tax?.price ||
            0
          ).toFixed(2),
          priceCurrency: "SAR",
          priceType: "https://schema.org/ListPrice",
        },
      ],
    },
  };

  useEffect(() => {
    if (
      typeof window != undefined &&
      document.querySelector(".yarl__slide_image")
    ) {
      document.querySelector(".yarl__slide_image").style.minWidth = "1200px";
      document.querySelector(".yarl__slide_image").style.minHeight = "1200px";
    }
  }, []);

  const lastProductAlgoliaMemo = useMemo(
    () => (
      <LastProductAlgolia
        entity_id={productData?.entity_id}
        locale={locale}
        t={t}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [productData?.entity_id, locale]
  );

  // og product:availability — derive from the search-index stock flag. The flag
  // may be flat (Typesense PDP doc) or nested under `stock` (ES). Only an
  // explicit out-of-stock flips it; otherwise default to "in stock".
  const stockFlag =
    productData?.is_in_stock ??
    productData?.in_stock ??
    productData?.stock?.is_in_stock;
  const ogAvailability =
    stockFlag === false || stockFlag === 0 || stockFlag === "0"
      ? "out of stock"
      : "in stock";

  return (
    <>
      <SEO
        title={productData?.name || ""}
        description={product_meta_desc(productData?.name, locale)}
        image={productData?.image}
        pathname={"/product/" + productData?.rewrite_url}
        ogType="product"
        condition={productData?.new}
        brand={
          Array.isArray(productData?.option_text_brand)
            ? productData?.option_text_brand?.[0]
            : productData?.option_text_brand
        }
        availability={ogAvailability}
        priceAmount={(+productData?.prices_with_tax?.price || 0).toFixed(2)}
        priceCurrency="SAR"
      >
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: serializeJsonLd(productScheema, 2),
          }}
        />
        <link
          rel="canonical"
          href={buildCanonicalUrl(
            `/product/${productData?.rewrite_url === "/" ? "" : productData?.rewrite_url}`,
            locale
          )}
        />
      </SEO>
      <section>
        <ProductBreadCrumb product={productData} />
        <div className="w-[80%] max-[570px]:w-[98%] mx-auto my-5 max-md:my-2">
          <div className="grid grid-cols-12 gap-4">
            <Album images={productData?._media_?.image} product={productData} />
            <Detail
              product={productData}
              relatedProducts={[]}
              ratings={ratings}
              pdp_details={pdp_details}
              setShowBranches={setShowBranches}
              store={store}
              city={city}
              setCity={setCity}
              t={t}
              queryId={query?.queryID}
              indexName={indexName}
              paymentWidgets={paymentWidgets}
              isMobile={isMobile}
              extendedWarranty={extendedWarranty}
            />
          </div>
          {productData?.free_gifts?.length > 0 ? (
            <FreeProduct items={productData?.free_gifts} />
          ) : null}
          {productData?.bundle_discount_products?.length > 0 &&
            productData?.bundle_discount_products?.map((bundle, index) => {
              let checkerOfParentId = checkPArentID(index);
              return (
                <>
                  {checkerOfParentId &&
                    currentDateTime <
                      productData?.bundle_discount_products[index]?.date_to &&
                    currentDateTime >
                      productData?.bundle_discount_products[index]
                        ?.date_from && (
                      <ProductsBundle
                        {...{
                          product: productData,
                          bundle,
                          relatedProducts: [],
                          t,
                        }}
                      />
                    )}
                </>
              );
            })}
          <Descriptions
            description={productData?.short_description}
            attributes={productData?.product_attributes}
            returnPolicy={productData?.return_policy}
            t={t}
          />
          <FlixMedia product={productData} />
          <TTLStreamContent
            {...{
              sku: productData?.sku,
              brand: productData?.option_text_brand?.at(0),
              locale,
            }}
          />
          <Rating {...{ t, setAddRate, ratings }} />
        </div>

        {/* {relatedProducts && relatedProducts?.length ? (
          <ProductsBy
            products={relatedProducts}
            title={t("RelatedProducts")}
            show={false}
            noOutOfStockProducts={true}
            showBackordersAnyway={true}
          />
        ) : null}
        {sameBrandProducts && sameBrandProducts?.length ? (
          <ProductsBy
            products={sameBrandProducts}
            title={t("SameBrandProducts")}
            show={false}
            noOutOfStockProducts={true}
            showBackordersAnyway={true}
          />
        ) : null}
        {frequentlyBoughtTogetherProducts &&
        frequentlyBoughtTogetherProducts?.length ? (
          <ProductsBy
            products={frequentlyBoughtTogetherProducts}
            title={t("Frequently Bought Together Products")}
            show={false}
            noOutOfStockProducts={true}
            showBackordersAnyway={true}
          />
        ) : null}

        {alsoViewedProducts && alsoViewedProducts?.length ? (
          <ProductsBy
            products={alsoViewedProducts}
            title={t("Customer Who Viewed This Product Also Viewed")}
            show={false}
            noOutOfStockProducts={true}
            showBackordersAnyway={true}
          />
        ) : null} */}
        {lastProductAlgoliaMemo}
        <div id="webengage_webP_recommendation"></div>
      </section>

      {addRate && productData ? (
        <AddNewRate {...{ setAddRate, t, productData }} />
      ) : null}
      {showBranches ? (
        <AllBranches {...{ setShowBranches, branches: store, city }} />
      ) : null}
    </>
  );
};

export default ProductDetailsPage;

export async function getServerSideProps({
  locale,
  params: { rewrite_url },
  req,
  res,
}) {
  const closedSiteRedirect = guardClosedSite({ req });
  if (closedSiteRedirect) return closedSiteRedirect;
  const userAgent = req.headers["user-agent"] || "";
  const isMobile =
    /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/i.test(
      userAgent
    );

  const parsedSku = rewrite_url.slice(rewrite_url?.lastIndexOf("-p-") + 3);
  const sku = parsedSku.includes("-")
    ? parsedSku.slice(0, parsedSku.indexOf("-"))
    : parsedSku;

  const handshake =
    req.cookies[handshakeCookieName(locale)] ||
    (await localeHandShake(locale, { req, res }))?.data?.token;
  const product = IS_TYPESENSE_GLOBAL
    ? await tssGetProductBySkuWithPreset(sku, locale)
    : await getProductBySku(sku, handshake);
  const pdp_details = await getActivePdpDetails(handshake);
  const productPath = product?.data ? product?.data?.[0]?._source : {};
  if (!productPath?.sku) {
    return {
      notFound: true,
    };
  }

  const product_data = {
    ...productPath,
    stock: {
      is_in_stock: productPath["1101"]?.value > 0,
      qty: productPath["1101"]?.value || 0,
    },
  };

  const paymentMethodsExtraInfo = await getPaymentMethodsExtraInfo({
    handshake,
    cartId: "",
    sku: product_data?.sku,
    price: getDisplayedProductPrice(product_data?.prices_with_tax),
  });
  // Fetch Extended Warranty options for this SKU. Empty / errored response
  // means the SKU is not EW-eligible; the FE hides the section.
  const {data: ewData} = await getExtendedWarrantyOptions(handshake, undefined, sku);
  
    const extendedWarranty = ewData?.data && Array.isArray(ewData?.data?.prices) && ewData?.data?.prices?.length > 0
      ? ewData.data
      : null;

  // Prioritize APS Installment in the payment widgets list
  if (paymentMethodsExtraInfo?.data && paymentMethodsExtraInfo?.data?.length > 0) {
    const apsInstallmentInfo = paymentMethodsExtraInfo.data.find(
      (method) => method?.code === "aps_installment"
    );
    if (apsInstallmentInfo) {
      paymentMethodsExtraInfo.data = [
        apsInstallmentInfo,
        ...paymentMethodsExtraInfo.data.filter(
          (method) => method?.code !== "aps_installment"
        ),
      ];
    }
  }

  return {
    props: {
      product: product_data,
      pdp_details: pdp_details?.data?.data || null,
      paymentWidgets: paymentMethodsExtraInfo?.data || [],
      isMobile,
      extendedWarranty,
      ...(await serverSideTranslations(locale, [
        "common",
        "product",
        "extended_warranty",
      ])),
    },
  };
}
